/**
 * Estado compartido para abrir/cerrar el modal de búsqueda global.
 *
 * Singleton module-level: el modal montado en `App.vue` y los disparadores
 * (botón de la biblioteca, atajo) comparten el mismo ref sin acoplar
 * componentes entre sí.
 */

import { ref } from 'vue'

const open = ref(false)

export function useGlobalSearchModal() {
  function show() {
    open.value = true
  }
  function hide() {
    open.value = false
  }
  function toggle() {
    open.value = !open.value
  }
  return { open, show, hide, toggle }
}
